module.exports = __webpack_public_path__ + "assets/img/img-map-nagasaki.51a28345.svg";